import React, { Component } from 'react';
import { withRouter, setCookie, getCookie, loginUrl } from './include/Common';
import {Helmet} from 'react-helmet';

import $ from 'jquery';
import axios from "axios";
import Footer from './Footer';

class WordList extends Component {
   constructor(props) {
      super(props);
      this.state = {
         totalCount: 0,
         wordList: [],     // 배열 데이터를 담음
         loading: true,
         page: 1,
         strword: '',
         order: 'abc',
         error: null,
         comboload: false,
      };
   }

   handleClick = (char) => {
      const element = document.getElementById(`dbtn-${char}`);
      element.classList.add('active');
      $('#dbtn-' + char).addClass('active');
      this.setState({ strword: char }, () => {
         this.props.navigate(`/WordList/${encodeURIComponent(char)}`);
      });

   };
//
   componentDidMount() {
      window.scrollTo(0, 0);
      const publicUrl = process.env.PUBLIC_URL;
      const searchWord = this.props.params.stext; // URL의 /Search/:stext 에 해당
      this.fetchWord(searchWord, '1');
      const tabLinks = document.querySelectorAll('.search-sort .tab-link');
      const tabContent = document.querySelector('.sort-list');
      // 각 탭에 해당하는 버튼 내용
      const tabData = {
         'sort-1': ['ㄱ', 'ㄴ', 'ㄷ', 'ㄹ', 'ㅁ', 'ㅂ', 'ㅅ', 'ㅇ', 'ㅈ', 'ㅊ', 'ㅋ', 'ㅌ', 'ㅍ', 'ㅎ', 'ㄲ', 'ㄸ', 'ㅃ', 'ㅆ', 'ㅉ'],
         'sort-2': [...'ABCDEFGHIJKLMNOPQRSTUVWXYZ'], // A~Z
         'sort-3': [...'0123456789'], // 0~9
      };

      const sortType = getSortType(searchWord);
      if (sortType == null) {
         updateSortList(tabData['sort-1']);
         $("#sort-1").addClass('active');
      } else {
         updateSortList(tabData[sortType]);
         $("#" + sortType).addClass('active');
      }
      if (!(searchWord === undefined || searchWord === null || searchWord === '')) {
         $('#dbtn-' + searchWord).addClass('active');
      }

      function getSortType(char) {
         for (const [key, arr] of Object.entries(tabData)) {
            if (arr.includes(char)) {
               return key;
            }
         }
         return null; // 해당하는 값이 없을 경우
      }

      // 탭 클릭 이벤트 추가
      tabLinks.forEach((tab) => {
         tab.addEventListener('click', function () {
            const selectedTab = this.getAttribute('data-tab');
            tabLinks.forEach((t) => t.classList.remove('active'));
            this.classList.add('active');
            updateSortList(tabData[selectedTab]);
            clickSortBtn();
         });
      });

      // sort-list 내용 업데이트 함수
      function updateSortList(items) {
         //console.log('load list');

         //tabContent.innerHTML = items.map((item) => `<li><button className="btn" title="${item}" type="button" onClick={() => this.handleClick("${item}")}>${item}</button></li>`).join('');
         tabContent.innerHTML = items
            .map(item => `<li><button class="btn" data-item="${item}" id="dbtn-${item}" type="button" title="${item}">${item}</button></li>`)
            .join('');
      }

      function clickSortBtn() {
         const buttons = document.querySelectorAll('.sort-list .btn');

         buttons.forEach((button) => {
            button.addEventListener('click', function () {
               const li = this.closest('li');
               const ul = li.parentElement;
               const siblingButtons = ul.querySelectorAll('li > .btn');

               // 모든 형제 버튼에서 active 제거
               siblingButtons.forEach((btn) => btn.classList.remove('active'));

               // 클릭한 버튼에 active 추가
               this.classList.add('active');
            });
         });
      }
      clickSortBtn();
      tabContent.addEventListener('click', (e) => {
         if (e.target.tagName === 'BUTTON') {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            const item = e.target.getAttribute('data-item');
            this.handleClick(item);
            const elements = document.querySelectorAll('[id^="dbtn-"]');
            elements.forEach(el => {
               el.classList.remove('active'); // 'active' 클래스 제거
            });
         }
      });
      $(document).on("click", ".comboBx__btn", function (e) {
         e.stopPropagation();

         const $btn = $(this);
         const $combo = $btn.closest(".comboBx");
         const $list = $combo.find(".comboBx__list");

         const isActive = $btn.hasClass("active");

         // 모든 콤보 초기화
         $(".comboBx__btn").removeClass("active");
         $(".comboBx__list").hide();

         // 현재 클릭한 것만 toggle
         if (!isActive) {
            $btn.addClass("active");
            $list.show();
         }
      });

      // 바깥 클릭 시 모든 콤보 닫기
      $(document).on("click", function () {
         $(".comboBx__btn").removeClass("active");
         $(".comboBx__list").hide();
      });
   }
   componentDidUpdate(prevProps) {
      const newKeyword = this.props.params.stext;
      const prevKeyword = prevProps.params.stext;

      if (prevKeyword !== newKeyword && this.state.searchWord !== newKeyword) {
         const element = document.getElementById(`dbtn-${newKeyword}`);
         element.classList.add('active');
         $('#dbtn-' + newKeyword).addClass('active');
         this.setState({ searchWord: newKeyword, page: 1 }, () => {
            this.fetchWord(newKeyword, '1');
         });
      }
   }
 
   async fetchWord(searchWord, page) {
      const publicUrl = process.env.PUBLIC_URL;
      $('#searchText').val(searchWord);

      // 예: axios 요청 가능
      //console.log(publicUrl + '/api/searchWordList.php?key=' + searchWord + '&pg=' + page + '&ob=' + this.state.order);
      try {
         const wordRes = await axios.get(publicUrl + '/api/searchWordList.php?key=' + searchWord + '&pg=' + page + '&ob=' + this.state.order);
         const wordData = wordRes.data;

         const wordItems = Object.keys(wordData)
            .filter(key => !isNaN(key))
            .map(key => wordData[key]);

         this.setState({
            totalCount: wordData.total,
            wordList: wordItems,
            loading: false,
            strword: searchWord,
         });
      } catch (error) {
         this.setState({
            error: error.message,
            loading: false,
            strword: searchWord,
         });
      };
   }

   handleSearchClick = (e) => {
      e.preventDefault(); // a 태그의 기본 동작 막기
      const { totalCount, totalNewsCount, wordList, newsList, loading, page, strword, error } = this.state;
      const trimmedKeyword = strword.trim(); // 앞뒤 공백 제거

      if (!trimmedKeyword || trimmedKeyword == '') {
         alert("검색어를 입력해주세요.");
         return; // 아무 것도 하지 않음
      }
      this.props.navigate(`/Search/${encodeURIComponent(strword)}`);
   }
   handleSearchChange = (e) => {
      this.setState({ strword: e.target.value });
   }

   handleButtonClick = async (idx) => {
      const element = document.getElementById(`btn-${idx}`);
      const isActive = element.classList.contains('active');
      let md = 'setZzim';
      if (!isActive) {
         md = 'unsetZzim';
      }
   };

   handleOrderClick = async (order) => {
      order == 'abc' ? $('.comboBx__btn').text('가나다순') : $('.comboBx__btn').text('최신순');
      $('.comboBx__list').hide();
      this.setState({ order: order }, () => {
         this.fetchWord(this.state.strword, '1');
      });
   }
   handleOrderListClick = () => {

   }

   render() {
      const { totalCount, totalNewsCount, wordList, newsList, relatedList, loading, page, order, strword, error } = this.state;
      const searchWord = this.props.params.stext;
      const currentUrl = window.location.href;
      const structureData = {
         "@context": "https://schema.org",
         "@type": "WebSite",
         "name": "용어 리스트 - 지식포켓",
         "url": currentUrl,
      }      
      ////
      return (
         <>
            <Helmet>

               <title>용어 리스트 - 지식포켓</title>
               <meta name="keywords" content="지식포켓, 뉴스 용어, 시사 용어, 오늘의 용어, 용어 검색, OX 퀴즈, 객관식 퀴즈, 십자말풀이, 시사 상식, 뉴스 해설, 용어 사전" />
               <meta name="description" content="경제·시사 상식을 쌓는 첫걸음, 용어 리스트! 최신 이슈부터 기본 개념까지 정리된 용어를 한눈에 확인하세요."/>

               <meta property="og:type" content="website" />
               <meta property="og:site_name" content="지식포켓" />
               <meta property="og:title" content="용어 리스트 - 지식포켓" />
               <meta property="og:description" content="경제·시사 상식을 쌓는 첫걸음, 용어 리스트! 최신 이슈부터 기본 개념까지 정리된 용어를 한눈에 확인하세요."/>
               <meta property="og:url" content={currentUrl} />
               <meta property="og:image" content="https://cwstatic.asiae.co.kr/pocket/og_img.png" /> 
               <meta property="og:image:width" content="1200" />
               <meta property="og:image:height" content="630" />
               <meta property="og:locale" content="ko_KR" />

               <link rel="canonical" href={currentUrl}/>
               <script type="application/ld+json">
               { JSON.stringify(structureData)}
               </script>                  
               
            </Helmet>               
            <main id="contents" data-page="word" className="page--word no-search-btn">
               <div className="container">
                  <div className="main-search">
                     <form className="main-search__form" method="post" autocomplete="off">
                        <button type="sumbit" className="main-search__btn" title="검색" onClick={this.handleSearchClick} />
                        <div className="input-wrap">
                           <input type="search" className="search-input" id="searchText" placeholder="궁금한 용어를 검색해 보세요!" value={this.state.strword} onChange={this.handleSearchChange} />
                        </div>
                        <button className="search-input__del" type="button" title="내용 삭제"> </button>
                     </form>
                  </div>
               </div>
               <></>
               <div className="search-sort">
                  <ul className="tab-box">
                     <li><button data-tab="sort-1" id="sort-1" className="tab-link">초성</button></li>
                     <li><button data-tab="sort-2" id="sort-2" className="tab-link">알파벳</button></li>
                     <li><button data-tab="sort-3" id="sort-3" className="tab-link">숫자</button></li>
                  </ul>
                  <ul className="sort-list">

                  </ul>

               </div>

               <section className="section">
                  <div className="title-bx d-flex">
                     <h1 className="tit">용어 리스트</h1>

                     <div className="comboBx">
                        <button className="comboBx__btn" id="cbtn" onClick={() => this.handleOrderListClick()}>가나다순</button>
                        <ul className="comboBx__list">
                           <li><button type="button" id="orderBtn-1" onClick={() => this.handleOrderClick('abc')} className={order == 'abc' ? "link active" : "link"}>가나다순</button></li>
                           <li><button type="button" id="orderBtn-2" onClick={() => this.handleOrderClick('recent')} className={order == 'recent' ? "link active" : "link"}>최신순</button></li>
                        </ul>
                     </div>
                  </div>
                  <div className="container">
                     <ul className="word-list">
                        {(wordList && wordList.length > 0) ? (
                           wordList.map((item, index) => (
                              <li className="item">
                                 <a href={item ? `/View/${item.t_idx}` : '#'} className="link">
                                    <h3 className="title">{item.t_term}</h3>
                                    <p className="desc">{item.t_desc}</p>
                                 </a>
                              </li>
                           ))
                        ) : (
                           <div className="no-result">
                              검색 결과가 없습니다.
                           </div>
                        )}
                     </ul>
                     <Pagination
                        totalCount={totalCount}
                        currentPage={page}
                        perPage={10}
                        onPageChange={(page) => {
                           this.setState({
                              page: page
                           });
                           window.scrollTo({ top: 0, behavior: 'smooth' });
                           this.fetchWord(searchWord, page);
                           const element = document.getElementById(`dbtn-${searchWord}`);
                           element.classList.add('active');
                           // 페이지 변경 처리 로직
                        }}
                     />

                  </div>
               </section>
            </main>
            <Footer />
         </>
      );
   }
}

function Pagination({ totalCount, currentPage, perPage = 10, onPageChange }) {
   const totalPages = Math.ceil(totalCount / perPage);
   const maxVisiblePages = 5;

   const getPageNumbers = () => {
      const pages = [];
      let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
      let endPage = startPage + maxVisiblePages - 1;

      if (endPage > totalPages) {
         endPage = totalPages;
         startPage = Math.max(1, endPage - maxVisiblePages + 1);
      }

      for (let i = startPage; i <= endPage; i++) {
         pages.push(i);
      }
      return pages;
   };

   const pages = getPageNumbers();

   return (
      <div className="pagination">
         <ul>
            {currentPage > 1 && (
               <li className="btn_prev">
                  <a href="#none" title="이전" onClick={() => onPageChange(currentPage - 1)}>
                     <i><em>이전 아이콘</em></i>
                  </a>
               </li>
            )}

            {pages.map((page) => (
               <li key={page} className={page === currentPage ? 'selected' : ''}>
                  <a href="#none" title={page} onClick={() => onPageChange(page)}>
                     {page}
                  </a>
               </li>
            ))}

            {currentPage < totalPages && (
               <li className="btn_next">
                  <a href="#none" title="다음" onClick={() => onPageChange(currentPage + 1)}>
                     <i><em>다음 아이콘</em></i>
                  </a>
               </li>
            )}
         </ul>
      </div>
   );
}

export default withRouter(WordList);